import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { signout } from "../../helpers/helpers"
import cookie from "js-cookie"

const Signout = () => {
    const navigate = useNavigate()

    useEffect(() => {
        signout()
        cookie.remove("token")
        window.location.href = "https://arbitrage.sk"
    }, [])

    return null
}

export default Signout
